// @ts-nocheck
import { createFileRoute } from '@tanstack/react-router';
import CustomerZoneJobListPage from '@/PageComponents/CustomerZone/CustomerZoneJob/CustomerZoneJobListPage';

export default CustomerZoneJobListPage;
export const Route = createFileRoute('/_customerzoneLayout/customerzone/joblist')({ component: CustomerZoneJobListPage });
